<elcia-card>
  <a [routerLink]="link()" class="flex h-full min-w-0 flex-col justify-center gap-1 no-underline">

    <div class="flex items-center gap-2">
      <span [class]="icon()" aria-hidden="true" class="pi flex-none text-sm text-[var(--p-surface-400)]"></span>
      <span class="min-w-0 truncate text-xs text-[var(--p-surface-600)]">{{ label() }}</span>
    </div>

    <div class="flex flex-wrap items-baseline gap-x-2">
      <span class="text-2xl font-bold tabular-nums">{{ value() }}</span>
      <span [class]="deltaClass()" class="text-xs font-semibold tabular-nums">{{ deltaLabel() }}</span>
    </div>

    @if (hint()) {
      <span class="truncate text-xs text-[var(--p-surface-500)]">{{ hint() }}</span>
    }
  </a>
</elcia-card>
